// Single source of truth for subscription tiers — matches backend
// `subscription-plan` content type and Stripe price IDs (see docs/billing.md).
// Prices are MXN/month, IVA incluido. Used by both pricing.jsx and the
// home PricingTeaser so the numbers never drift.
// trialDays: sólo el plan inicial lleva prueba (acuerdo 28-may-2026) — el
// backend lo aplica en el checkout (subscription-plan.trial_days).
export const PLANS = [
  { slug: 'tier-20',        rango: '1 – 20',         max: 20,    price: 200,  popular: false, trialDays: 15 },
  { slug: 'tier-50',        rango: '21 – 50',        max: 50,    price: 350,  popular: false, trialDays: null },
  { slug: 'tier-200',       rango: '51 – 200',       max: 200,   price: 700,  popular: true,  trialDays: null },
  { slug: 'tier-500',       rango: '201 – 500',      max: 500,   price: 850,  popular: false, trialDays: null },
  { slug: 'tier-2500',      rango: '501 – 2,500',    max: 2500,  price: 2500, popular: false, trialDays: null },
  { slug: 'tier-5000',      rango: '2,501 – 5,000',  max: 5000,  price: 4500, popular: false, trialDays: null },
  { slug: 'tier-unlimited', rango: '5,001 +',        max: null,  price: 6500, popular: false, trialDays: null },
];

export const COMMON_FEATURES = [
  'Sincronización automática con el SAT',
  'Portal de consulta para colaboradores 24/7',
  'Descarga de recibos en PDF y XML',
  'Bitácora y evidencia para auditoría',
  'Cifrado extremo a extremo',
  'Almacenamiento ilimitado de comprobantes',
  'Soporte en español',
];

export const formatMXN = (n) => n.toLocaleString('es-MX');
